module.exports = __webpack_public_path__ + "static/media/desktopScreenshot05.21c72169.jpg";